import { Links } from "config/links"

import { useTailwindBreakpoints } from "components/hooks/use-tailwind-breakpoints"

import { BackgroundImage } from "components/shared/background-img"
import { Box } from "components/shared/box"
import { Button } from "components/shared/landing/button"
import { Link } from "components/shared/link"
import { Text } from "components/shared/text"
import { TitleDivider } from "components/shared/title-divider"

import { BotWithRectangle } from "./bot-with-rectangle"

const bots3dImages = [
  {
    imgSrc: "/images/pages/bot-3d/rarity-section/bot_1.png",
    title: "Common",
    text: "A unique 3D version of every Classic Cryptobot available",
  },
  {
    imgSrc: "/images/pages/bot-3d/rarity-section/bot_2.png",
    title: "Rare",
    text: "Same as common but with veteran features obtained in the previous combats",
  },
  {
    imgSrc: "/images/pages/bot-3d/rarity-section/bot_3.png",
    title: "Epic",
    text: "Completely unique super rare bots (only 10 available!)",
  },
]

export function RaritySection() {
  const { xs } = useTailwindBreakpoints()
  return (
    <BackgroundImage
      imageSrc="/images/pages/bot-3d/faq-section/bg-faq.jpg"
      className="bg-cover bg-no-repeat bg-bottom pt-10 "
    >
      <Box center>
        <Box className="relative w-full md:mb-4 text-white p-6">
          <Box className="absolute w-[500px] h-[600px] top-[500px] lg:top-0  right-[-100px] bg-[url(/images/pages/bot-3d/rarity-section/side_bot.png)] lg:w-[600px] lg:h-[600px]" />

          <Box className="mb-15 lg:max-w-[600px]">
            <Text as="h2" className="text-[48px] leading-[48px] lg:max-w-[300px] mb-4  uppercase">
              Rarity&nbsp;Types
            </Text>
            <TitleDivider className="mb-6" />
            <Text className="text-[1.2rem] leading-[2rem] mb-6">
              3D Classic Bots have 3 tiers — Common, Rare, and Epic. The tiers will appear on minting with different
              probability.
            </Text>
            <Text className="text-[1.2rem] leading-[2rem] mb-6">
              * Every Fancy Classic Cryptobot holder gets the same 3D Fancy bot, no other mutations applicable.
            </Text>
            <div>
              <Link href={Links.OPENSEA_WRAPP} target="_blank" highlightOnHover={false} className="flex-1">
                <Button size="lg" className="mt-4 uppercase">
                  Become a holder
                </Button>
              </Link>
            </div>
          </Box>
          <Box className="sm:mb-0">
            <Box row={!xs} className="justify-arround top-24 mt-8 sm:mt-0 w-full gap-[40px] sm:gap-0">
              {bots3dImages.map(bot => (
                <BotWithRectangle key={bot.imgSrc} imgSrc={bot.imgSrc} title={bot.title} text={bot.text} />
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </BackgroundImage>
  )
}
